<template>
  <transition
    appear
    @before-appear="beforeAppear"
    @appear="enter"
    @enter="enter"
    @leave="leave">
    <h3
      :key="chapter"
      class="chapter">
      {{'chapter ' + chapter}}
    </h3>
  </transition>
</template>

<script>
import anime from 'animejs';
import { SplitText } from '@/scripts/SplitText';

export default {
  name: 'HeroChapter',
  computed: {
    chapter() {
      return this.$store.getters.getCurrentPage.chapter;
    },

  },
  mounted() {
    return new SplitText(this.$el, { charsClass: 'stagger-element' });
  },
  methods: {
    beforeAppear(el) {
      anime.set(el, {
        opacity: 0,
      });
    },
    enter(el, done) {
      anime({
        targets: el,
        opacity: 1,
        duration: 800,
        easing: 'easeInCubic',
        complete() {
          done();
        },
      });
    },
    leave(el, done) {
      anime({
        targets: el,
        opacity: 0,
        duration: 800,
        easing: 'easeOutCubic',
        complete() {
          done();
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.chapter {
  text-transform: uppercase;

  pointer-events: none;
  cursor: default;
}
</style>
